import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { IOType } from '../../io/types';
import { SimpleIOModal } from '../../io/VOBbased/SimpleIOModal';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const SimpleIOModalWidget = () => {
    const component = useMemo(() => (_jsx(Stack, { direction: "row", children: _jsx(SimpleIOModal, { initialIOType: IOType.IMPORT, allowIOTypeToggle: true, plainObjects: [], setPlainObjectsInParent: () => { } }) })), []);
    return {
        name: 'SimpleIOModal',
        category: 'composite',
        component,
    };
};
